import { msg } from 'api';

import {
  CLOSE_FEEDBACK_MODAL,
  SET_FEEDBACK_HAS_ERROR,
  SET_FEEDBACK_OPTIONS,
  SET_FEEDBACK_SENT,
  TOGGLE_FEEDBACK_POPUP,
} from '../actions/feedbackPopup';

const defaultFeedbackOption = {
  value: '',
  name: msg.feedbackPopup.fieldCategoryPlaceholder,
};

const transformFeedbackOptions = (options) =>
  options.map(option => ({
    value: option.id.toString(),
    name: option.displayName,
  }));

export const initialState = {
  feedbackOptions: [defaultFeedbackOption],
  hasError: false,
  isPopupOpened: false,
  isFeedbackSent: false,
};

export default function feedbackPopup(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_FEEDBACK_POPUP: {
      return {
        ...state,
        isPopupOpened: !state.isPopupOpened,
      };
    }
    case SET_FEEDBACK_SENT: {
      return {
        ...state,
        isFeedbackSent: true,
      };
    }
    case SET_FEEDBACK_HAS_ERROR: {
      return {
        ...state,
        hasError: true,
      };
    }
    case CLOSE_FEEDBACK_MODAL: {
      return {
        ...state,
        hasError: false,
        isFeedbackSent: false,
        isPopupOpened: false,
      };
    }
    case SET_FEEDBACK_OPTIONS: {
      return {
        ...state,
        feedbackOptions: [
          defaultFeedbackOption,
          ...transformFeedbackOptions(action.data),
        ],
      };
    }
    default: {
      return state;
    }
  }
}
